<div
  class="form"
  [formGroup]="form"
  *ngIf="getIteration(data.slotSchedule, data.date)"
  [style.display]="(currentDays$ | async)?.length ? 'block' : 'none'"
>
  <crm-wfm-file-upload-input
    [validationParseData]="customTimeWeightsValid"
    (uploadedData)="uploadCustomTimeWeights($event)"
  ></crm-wfm-file-upload-input>
  <table
    mat-table
    multiTemplateDataRows
    [dataSource]="customTimeWeightsDataSource"
    [formArrayName]="forecastWeightsEnum.customTimeWeightsGroup"
  >
    <ng-container matColumnDef="{{ column }}" *ngFor="let column of customTimeWeightsColumnsToDisplay; let d = index">
      <ng-container *matHeaderCellDef>
        <th mat-header-cell *ngIf="d === 0 || (currentDays$ | async)?.includes(d.toString())">
          {{ column | transloco }}
        </th>
      </ng-container>
      <ng-container *matCellDef="let element; let s = dataIndex">
        <td mat-cell *ngIf="d === 0 || (currentDays$ | async)?.includes(d.toString())" [formGroupName]="s">
          <strong *ngIf="d === 0">{{ element[d] }}</strong>
          <div *ngIf="d !== 0">
            <input class="weight-block-weight-number" type="number" matInput [formControlName]="d - 1" />
            <mat-error *ngIf="isInvalid(s, d - 1)">
              {{ 'wfmModule.errors.incorrectValue' | transloco }}
            </mat-error>
          </div>
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="customTimeWeightsColumnsToDisplay"></tr>
    <tr mat-row *matRowDef="let element; columns: customTimeWeightsColumnsToDisplay"></tr>
  </table>
</div>
